import { ReactNode } from 'react';
import styled from 'styled-components';

import { theme } from './ui/theme';

interface PageGridProps {
    children: ReactNode;
}

export const PageGrid = styled.div<PageGridProps>`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.space[16]};
`;
